import * as React from "react";
import { renderLiveScore } from "./renderLiveScore";
import { renderKickOffState } from "./renderKickOffState";
export var renderLiveDetails = function (event, componentPrefix, dict) {
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__scores", "data-uat": "div-ev-list-" + componentPrefix + "-scores" }, renderLiveScore(event)),
        event.isInKickOffState && renderKickOffState(event, componentPrefix, dict));
};
//# sourceMappingURL=renderLiveDetails.js.map